import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import { IonIcon } from "@ionic/react";
import { checkmarkOutline } from "ionicons/icons";

import { tRootState } from "../../../store";
import { clearBillData } from "../../../store/paybillsSlice";

import DashboardLayout from "../../../layouts/DashboardLayout/DashboardLayout";
import { roundDP } from "../../../utils/func";

const ElectricitySuccessful = () => {
  const dispatch = useDispatch();

  const { serviceProvider, recipient, verification, amount } = useSelector(
    (state: tRootState) => state.paybills.electricity
  );

  const clearData = useCallback(
    () => dispatch(clearBillData("electricity")),
    [dispatch]
  );

  useEffect(() => {
    const interval = window.setInterval(() => {
      clearData();
      window.clearInterval(interval);
    }, 4000);
  }, [clearData]);

  if (!serviceProvider || !recipient || !verification || !amount)
    return <Navigate to="/pay-bills/electricity" />;

  return (
    <DashboardLayout>
      <div className="pay-bills-block">
        <div className="text-center mb-medium">
          <div className="success-icon-block">
            <div>
              <IonIcon icon={checkmarkOutline} />
            </div>
          </div>
        </div>
        <h3 className="pay-bills-block__success-heading">
          Electricity Purchase Successful
        </h3>
        <p className="pay-bills-block__success-text">
          Your Electricity Purchase of &#8358;{roundDP(amount, 2)} was
          Successfully sent to
          <span>{verification}</span>! Thank you for choosing SekiApp
        </p>
        <div className="auth__footer">
          <button
            className="form-button form-button--active"
            onClick={clearData}
          >
            Finish
          </button>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default ElectricitySuccessful;
